// extracted by mini-css-extract-plugin
export default {"badge":"Badge_badge__7VZ1-","badge__main":"Badge_badge__main__isU4I","badge__secondary":"Badge_badge__secondary__Ofbuj"};